var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line Duotone / Users / Users Group Two Rounded",
    clipPath: "url(#clip0_2406_2657)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Vector",
    cx: 13,
    cy: 6.625,
    r: 4.25,
    stroke: "#1C274C",
    strokeWidth: 1.59375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M19.375 9.8125C21.1354 9.8125 22.5625 8.62326 22.5625 7.15625C22.5625 5.68924 21.1354 4.5 19.375 4.5",
    stroke: "#1C274C",
    strokeWidth: 1.59375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.5,
    d: "M6.625 9.8125C4.86459 9.8125 3.4375 8.62326 3.4375 7.15625C3.4375 5.68924 4.86459 4.5 6.625 4.5",
    stroke: "#1C274C",
    strokeWidth: 1.59375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Vector_4",
    cx: 13,
    cy: 18.3125,
    rx: 6.375,
    ry: 4.25,
    stroke: "#1C274C",
    strokeWidth: 1.59375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.5,
    d: "M21.5 20.4375C23.3639 20.0288 24.6875 18.9936 24.6875 17.7812C24.6875 16.5689 23.3639 15.5337 21.5 15.125",
    stroke: "#1C274C",
    strokeWidth: 1.59375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.5,
    d: "M4.5 20.4375C2.63611 20.0288 1.3125 18.9936 1.3125 17.7812C1.3125 16.5689 2.63611 15.5337 4.5 15.125",
    stroke: "#1C274C",
    strokeWidth: 1.59375,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2406_2657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 25.5,
    fill: "white",
    transform: "translate(0.25 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.fc6f3f4ceadacc026a3f6b5bce92252f.svg";
export { ForwardRef as ReactComponent };